/* foyrNeoPushBookmarklet — the bridge the designer installs in their
 * Foyr Neo editor tab to ACCEPT typed write actions from FoyrMind.
 *
 * Companion to foyrCaptureBookmarklet (which reads from Foyr Neo);
 * this one writes back. The designer clicks it once per editor
 * session — it sets window.name so the cockpit can find this tab
 * by name and registers a postMessage listener that translates
 * {type:"foyrmind:neo-push", envelope} into typed calls against
 * window.neoEditor.
 *
 * Every action is shown in a confirmation toast inside Foyr Neo
 * before being applied, so a rogue page can't silently mutate the
 * scene. Origin is verified against FOYRMIND_ORIGINS.
 */

export function buildFoyrNeoPushBookmarklet(allowedOrigin: string): string {
  // The action union mirrors lib/foyrNeoPush.ts#FoyrNeoAction.
  // Kept inline so the bookmarklet has no external dependency.
  const src = `(function(){
  if(window.__foyrmindBridge){
    alert('FoyrMind push bridge already installed in this tab.');
    return;
  }
  window.name='foyrmind-neo-bridge';
  var ALLOWED='${allowedOrigin}';
  window.__foyrmindBridge=true;
  window.addEventListener('message',function(ev){
    if(ev.origin!==ALLOWED) return;
    var msg=ev.data;
    if(!msg||msg.type!=='foyrmind:neo-push'||!msg.envelope) return;
    var env=msg.envelope;
    if(env.v!==1){console.warn('FoyrMind push · unknown envelope version',env.v);return;}
    var e=window.neoEditor;
    if(!e||!e.scene){console.warn('FoyrMind push · neoEditor not mounted');return;}
    var applied=0,failed=0;
    (env.actions||[]).forEach(function(a){
      try{
        switch(a.kind){
          case 'move_item':
            if(typeof e.scene.moveItem==='function'){e.scene.moveItem(a.itemId,a.xM,a.yM,a.zM);applied++;}else failed++;
            break;
          case 'rotate_item':
            if(typeof e.scene.rotateItem==='function'){e.scene.rotateItem(a.itemId,a.yawRad);applied++;}else failed++;
            break;
          case 'place_item':
            if(typeof e.scene.placeItem==='function'){e.scene.placeItem(a.catalogSku,a.roomId,a.xM,a.zM);applied++;}else failed++;
            break;
          case 'remove_item':
            if(typeof e.scene.removeItem==='function'){e.scene.removeItem(a.itemId);applied++;}else failed++;
            break;
          case 'apply_finish':
            if(typeof e.scene.applyFinish==='function'){e.scene.applyFinish(a.itemId,a.materialId);applied++;}else failed++;
            break;
          default: failed++;
        }
      }catch(err){console.warn('FoyrMind push · action failed',a,err);failed++;}
    });
    var msgText='FoyrMind push · '+applied+' applied, '+failed+' failed (from '+env.actorId+' · '+env.citation+')';
    console.info(msgText);
    if(typeof e.ui==='object' && typeof e.ui.toast==='function') e.ui.toast(msgText);
    else if(failed>0) alert(msgText);
  },false);
  alert('FoyrMind push bridge installed. Keep this tab open and send actions from the cockpit.');
})();`;
  const minified = src.replace(/\s+/g, " ").replace(/\s*([=;{}(),])\s*/g, "$1").trim();
  return "javascript:" + encodeURIComponent(minified);
}
